export const customStyles = {
  header: {
    style: {
      minHeight: '56px',
      fontWeight: 'bolder',
      color: '#000',
    },
  },
  headRow: {
    style: {},
  },
  headCells: {
    style: {
      fontSize: '18px',
    },
  },
  cells: {
    style: {},
  },
};

export const pageOptions = {
  rowsPerPageText: 'Linhas Por Página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};
